export const SET_STICKY = Symbol('SET_STICKY');

export function setSticky(val) {
    return {
        type: SET_STICKY,
        payload: val
    }
}
